import React, { Component } from 'react';
import ReviewRequests from '../../components/ReviewRequests';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchRequests, getRequests } from '../../modules/requests';

class RequstList extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };

  async componentDidMount() {
    const { fetchRequests } = this.props;
    await fetchRequests();
  }

  navTo = (id, cat) => {
    const { router } = this.context;
    const url = `/${cat}${id ? `/${id}` : ''}`;
    router.history.push(url);
  };

  render() {
    const { requests } = this.props;
    return <ReviewRequests navTo={this.navTo} requests={requests} />;
  }
}

export default connect(
  state => ({
    requests: getRequests(state),
  }),
  { fetchRequests }
)(RequstList);



// WEBPACK FOOTER //
// ./src/containers/RequstList/index.js